/*global anime */
import { Card } from 'react-bootstrap'
import { useLayoutEffect, useRef, useEffect, useState, useCallback, useMemo } from 'react';
import useLayout from '#Context/Layout'
import useGeneralContext from '#Context/General'
import { setCanvasDimensions, draw } from './canvasOps.js'
import '../ScrollingCard/styles.css'; /*reuses same styles */
import './styles.css'

//THIS COMPONENT WAS MADE BY STRIPPING DOWN SCROLLINGCARD COMPONENT

const { Header, Footer, Body } = Card;

export default function CustomCard(props) {
    const { platform } = useLayout();
    const { circuitImg2 } = useGeneralContext(); 
    const { drawWhenLoaded } = circuitImg2; 
    //prop initializing
    let { id, index, header, classString, style={}, Element, children } = props;
    let { icon, headText, size, w0, h0, HeadElement, rulerSize } = header
    if (!size) size = 52
    if (!rulerSize) rulerSize = 48

    //react state
    const card = useRef(null);
    const headerCanvas = useRef(null);
    const [boundingRect, setBoundingRect] = useState(null);

    const resize = useCallback(() => {
        setBoundingRect(card.current.getBoundingClientRect())
    }, [])

    useLayoutEffect(() => {
        //simplest solution was to run this check on every render
        if (!card.current) return;
        if (!boundingRect || boundingRect.height !== card.current.getBoundingClientRect().height) resize();
        else if (boundingRect.width !== card.current.getBoundingClientRect().width) resize();
    } )

    useLayoutEffect(() => {
        if (!boundingRect) return
        setCanvasDimensions(headerCanvas.current, boundingRect.width, size);
        drawWhenLoaded(() => {
            draw(headerCanvas.current, circuitImg2.img, index, w0, h0);
        })
    }, [boundingRect])

    useEffect(() => {
        window.addEventListener('resize', resize);
        return () => window.removeEventListener('resize', resize);
    }, [])

    return (
        <Card id={id} ref={card} style={style}
            className={`customCard1 rounded ${classString || ''} `}>
            <Header className="roundedTop p-0 d-flex" style={{ height: size, }}>
                <canvas ref={headerCanvas} className="position-absolute roundedTop" style={{ zIndex: 1 }}></canvas>
                {HeadElement
                    ? <HeadElement></HeadElement>
                    : <h5 className="px-3 m-0 mt-1 align-self-center" style={{ zIndex: 2 }}>{icon ? <i className={`fa fa-${icon}`}></i> : '❖ '} <span className="d-inline-block ms-3">{headText}</span></h5>
                }
                <div className={`headRuler ruler w-100`} style={{ height: rulerSize }}></div>
            </Header>
            <Body className="p-0 pb-3 position-relative roundedBottom d-flex" style={{zIndex: 3, overflow: 'hidden'}}>
                <div className="pt-4 px-md-4 pb-0 position-relative d-flex w-100">
                    {Element
                        ? <Element wide={platform === 'desktop'}></Element>
                        : children}
                </div>
            </Body>
            <div className="staticCardGlow rounded"></div>
        </Card>
    )
}
